import { render, staticRenderFns } from "./TimesheetBudget.vue?vue&type=template&id=5dd04b53"
import script from "./TimesheetBudget.vue?vue&type=script&lang=js"
export * from "./TimesheetBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd04b53')) {
      api.createRecord('5dd04b53', component.options)
    } else {
      api.reload('5dd04b53', component.options)
    }
    module.hot.accept("./TimesheetBudget.vue?vue&type=template&id=5dd04b53", function () {
      api.rerender('5dd04b53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/taskdetails/TimesheetBudget.vue"
export default component.exports